export const PLAYLIST_LOADING  = "PLAYLIST_LOADING";
export const PLAYLIST_SET_DATA  = "PLAYLIST_SET_DATA";
export const PLAYLIST_SET_DETAILS  = "PLAYLIST_SET_DETAILS";
export const PLAYLIST_SET_OWN_DATA  = "PLAYLIST_SET_OWN_DATA";
export const PLAYLIST_SET_FOLLOWING_DATA  = "PLAYLIST_SET_FOLLOWING_DATA";

export const CREATE_SESSION_START = "CREATE_SESSION_START";
export const CREATE_SESSION_SUCCESS = "CREATE_SESSION_SUCCESS";
export const CREATE_SESSION_FAILURE = "CREATE_SESSION_FAILURE";

export const GET_SESSION_START = "GET_SESSION_START";
export const GET_SESSION_SUCCESS = "GET_SESSION_SUCCESS";
export const GET_SESSION_FAILURE = "GET_SESSION_FAILURE";

export const GET_SESSION_BY_USER_START = "GET_SESSION_BY_USER_START";
export const GET_SESSION_BY_USER_SUCCESS = "GET_SESSION_BY_USER_SUCCESS";
export const GET_SESSION_BY_USER_FAILURE = "GET_SESSION_BY_USER_FAILURE";

export const SEARCH_START = "SEARCH_START";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_FAILURE = "SEARCH_FAILURE";

export const ENROLE_COURSE_START = "ENROLE_COURSE_START";
export const ENROLE_COURSE_SUCCESS = "ENROLE_COURSE_SUCCESS";
export const ENROLE_COURSE_FAILURE = "ENROLE_COURSE_FAILURE";

export const GET_ENROLE_COURSE_START = "GET_ENROLE_COURSE_START";
export const GET_ENROLE_COURSE_SUCCESS = "GET_ENROLE_COURSE_SUCCESS";
export const GET_ENROLE_COURSE_FAILURE = "GET_ENROLE_COURSE_FAILURE";